import { createRef, default as React, useState, useMemo, useEffect, useRef } from "react"
// eslint-disable-next-line
import _debounce from 'lodash.debounce'
import algoliasearch from "algoliasearch"
import { InstantSearch } from "react-instantsearch-dom"
import SearchBox from "./SearchBox"
import SearchResult from "./SearchResult"
import CurrentFilters from "./CurrentFilters"
import ContentCategoryFilter from "./ContentCategoryFilter"
import ContentTypeFilter from "./ContentTypeFilter"
import PopularSubjectsFilter from "./PopularSubjectsFilter"
import Pagination from "./Pagination"
import persistantOrder from "./persistantOrder"
import useClickOutside from "./useClickOutside"
import Heading from "src/components/Heading"
import MobileFilters from './MobileFilters'
import qs from 'qs';
import { navigate } from "gatsby"
import {BrowserView, MobileView} from 'react-device-detect'

const Search = ({ indices, location }) => {

    const createURL = state => `?${qs.stringify(state)}`

    const searchStateToUrl = searchState =>
      searchState ? createURL(searchState) : '';

    const urlToSearchState = ({ search }) => { 
      return qs.parse(search.slice(1))
    };
    
    const rootRef = createRef()
    const [hasFocus, setFocus] = useState(false)
    const DEBOUNCE_TIME = 400
    const searchClient = useMemo(
      () =>
        algoliasearch(
          "2CSOP59JJ4",
          "25ea052452773fac381d086de16eee35"
        ),
      []
    )
    useClickOutside(rootRef, () => setFocus(false))

    const [searchState, setSearchState] = useState(urlToSearchState(location));
    const debouncedSetStateRef = useRef(null);
  
    function onSearchStateChange(updatedSearchState) {

      clearTimeout(debouncedSetStateRef.current);

      debouncedSetStateRef.current = setTimeout(() => {
        navigate(searchStateToUrl(updatedSearchState));
      }, DEBOUNCE_TIME);
  
      setSearchState(updatedSearchState);
    }
  
    useEffect(() => {
      setSearchState(urlToSearchState(location));
    }, [location]);

    return (
        <InstantSearch
            searchClient={searchClient}
            indexName={indices[0].name}
            searchState={searchState}
            onSearchStateChange={onSearchStateChange}
            createURL={createURL}   
        >
            <div className="h-[30vh] w-full bg-darkgrey relative flex justify-center items-center">
              <Heading size="h1" className="text-white text-center xl:!mb-24 lg:!mb-28 2xl:!text-8xl xl:!text-5xl lg:!text-4xl md:!text-7xl !text-5xl">CX Insights <span className="text-red">Hub</span></Heading>
            </div>
            <div className="max-w-7xl mx-auto pb-16">
                <div className="w-full lg:-mt-28 -mt-10 relative z-100">
                  <div className="lg:max-w-6xl flex-grow mx-auto w-11/12">
                    <SearchBox onFocus={() => setFocus(true)} hasFocus={hasFocus} className="relative"/>
                    { <MobileView>
                        <MobileFilters>
                          <CurrentFilters />
                          <ContentCategoryFilter 
                            attribute="tag_list" 
                            transformItems={items => persistantOrder(items)}
                          />
                          <PopularSubjectsFilter 
                            attribute="popular_subjects" 
                            transformItems={items => persistantOrder(items)}
                          />
                          <ContentTypeFilter 
                            attribute="component" 
                            transformItems={items => persistantOrder(items)}
                          />
                        </MobileFilters>
                      </MobileView>
                    }
                    {
                      <BrowserView>
                        <ContentCategoryFilter 
                          attribute="tag_list" 
                          transformItems={items => persistantOrder(items)}
                        />
                        <PopularSubjectsFilter 
                          attribute="popular_subjects" 
                          transformItems={items => persistantOrder(items)}
                        />
                      </BrowserView>
                    }
                  </div>
                </div>              
                <div className="flex flex-row py-16">
                  <div className="w-1/5 px-6 hidden lg:block">
                    <Heading size="h3" className="text-darkgrey">Filters</Heading>
                    {
                      <BrowserView>
                        <CurrentFilters />
                        <ContentTypeFilter 
                          attribute="component" 
                          transformItems={items => persistantOrder(items)}
                        />
                      </BrowserView>
                    }
                  </div>
                  <div className="lg:w-4/5 w-full lg:px-0 px-6">
                    <SearchResult 
                      show={searchState && searchState.length > 0 && hasFocus} 
                      indices={indices}
                    />
                  </div>
                </div>
                <div>
                  <Pagination />
                </div>
            </div>
        </InstantSearch>            
    )
}

export default Search